module.exports = __webpack_public_path__ + "static/media/cancelar.abfda85e.svg";